import React from 'react';

export default function About({ onBack }) {
  return (
    <div style={{
      fontFamily: "'Montserrat', sans-serif",
      /* Deep radial gradient to give the 'glass' something to blur over */
      background: 'radial-gradient(circle at 50% 0%, #1a2a40 0%, #0a1628 80%)',
      minHeight: '100vh',
      color: '#fff',
      position: 'relative',
      /* Fix for mobile viewport height issues */
      minHeight: '-webkit-fill-available',
      overflowX: 'hidden',
    }}>
      
      {/* Sticky Navigation Header for Glass Effect */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        paddingTop: 'calc(10px + env(safe-area-inset-top))',
        paddingLeft: '20px',
        paddingRight: '20px',
        paddingBottom: '10px',
        /* Seamless gradient fade for header */
        background: 'linear-gradient(180deg, rgba(10,22,40,0.8) 0%, rgba(10,22,40,0) 100%)',
        pointerEvents: 'none' // Let clicks pass through the gradient area
      }}>
        {/* Back Button - "Bubble Pill" Style */}
        <button 
          onClick={onBack}
          className="ios-button"
          style={{
            pointerEvents: 'auto',
            appearance: 'none',
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: '30px', // Full pill shape
            color: '#e6c57e',
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '0.9rem',
            fontWeight: 600,
            letterSpacing: '0.05em',
            padding: '10px 20px 10px 16px', // Slightly unbalanced padding for optical alignment of arrow
            cursor: 'pointer',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
            WebkitTapHighlightColor: 'transparent',
            transition: 'all 0.2s cubic-bezier(0.25, 0.1, 0.25, 1)',
          }}
        >
          <span style={{ fontSize: '1.2rem', lineHeight: 0, marginBottom: '2px' }}>←</span> Back
        </button>
      </div>

      {/* Main Content Container */}
      <div style={{
        maxWidth: '600px', // Optimized for mobile read width
        margin: '0 auto',
        padding: '10px 24px 120px',
        paddingBottom: 'calc(120px + env(safe-area-inset-bottom))', // Extra space for bottom swipe
        boxSizing: 'border-box'
      }}>
        
        {/* Title Area */}
        <h1 style={{
          fontFamily: "'Bodoni Moda', serif",
          fontSize: 'clamp(3rem, 10vw, 4.5rem)',
          background: 'linear-gradient(180deg, #e6c57e 20%, #bf953f 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          letterSpacing: '-0.02em',
          fontWeight: 400,
          marginTop: '20px',
          marginBottom: '40px',
          textAlign: 'center',
          filter: 'drop-shadow(0px 4px 12px rgba(198,162,91,0.3))'
        }}>
          About
        </h1>

        {/* The Manifesto - Floating Glass Card */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.03)',
          backdropFilter: 'blur(30px)',
          WebkitBackdropFilter: 'blur(30px)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          borderRadius: '32px', // Apple "Squircle" feel
          padding: '32px 24px',
          boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
        }}>
          
          <div style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '1.05rem',
            lineHeight: 1.6,
            color: 'rgba(235, 235, 235, 0.9)',
            fontWeight: 400,
            textAlign: 'left'
          }}>
            
            <p style={{ marginBottom: '24px' }}>
              I love taking photos of random stuff. Always have. I used to post them on Instagram, 
              but at some point it got weird - too many features, too much going on.
            </p>

            <p style={{ marginBottom: '24px' }}>
              I wanted a simple spot to dump photos. See what my friends are up to. 
              <span style={{ color: '#e6c57e', fontWeight: 500 }}> no metrics. No AI slop.</span> Just photos.
            </p>

            <p style={{ marginBottom: '10px' }}>
              So I made this.
            </p>

            {/* "Inset Grouped" List Style (iOS Settings Style) */}
            <div style={{
              marginTop: '40px',
              marginBottom: '40px',
              borderRadius: '20px',
              overflow: 'hidden',
              background: 'rgba(0, 0, 0, 0.2)', // Slightly darker inner container
              border: '1px solid rgba(255,255,255,0.05)'
            }}>
              <div style={{
                padding: '16px 20px',
                borderBottom: '1px solid rgba(255,255,255,0.05)',
                background: 'rgba(255,255,255,0.02)',
              }}>
                <h3 style={{
                  margin: 0,
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: '0.85rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  color: 'rgba(255,255,255,0.5)',
                  fontWeight: 600
                }}>
                  What you can do
                </h3>
              </div>

              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {[
                  'Post photos - one or multiple, whatever',
                  'Add captions if you want, or don\'t',
                  'Make mood boards, document life',
                  'See posts chronologically',
                  'No follower counts, no likes'
                ].map((item, i, arr) => (
                  <li key={i} style={{
                    padding: '16px 20px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '12px',
                    borderBottom: i !== arr.length - 1 ? '1px solid rgba(255,255,255,0.05)' : 'none',
                    fontSize: '0.95rem',
                    color: '#d4d4d0'
                  }}>
                    <span style={{
                      color: '#c6a25b',
                      fontSize: '1.1rem',
                      lineHeight: '1',
                      marginTop: '1px'
                    }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <p style={{ marginBottom: '30px', fontSize: '0.95rem', opacity: 0.8 }}>
              a place to post photos without overthinking it.
            </p>

            <p style={{ 
              marginBottom: '0',
              color: '#e6c57e',
              fontStyle: 'italic',
              textAlign: 'center',
              marginTop: '40px',
              fontSize: '1.1rem',
              fontFamily: "'Bodoni Moda', serif",
            }}>
              ""
            </p>

          </div>
        </div>
      </div>

      {/* CSS Injection for Native Interaction Feel */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400;0,6..96,500;1,6..96,400&family=Montserrat:wght@300;400;500;600;700&display=swap');
        
        /* iOS Button Tap Effect */
        .ios-button:active {
          transform: scale(0.92);
          background: rgba(198,162,91,0.15) !important;
          border-color: #c6a25b !important;
        }

        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }
      `}</style>
    </div>
  );
}